import React from 'react';
import { connectionsDetailsLabels } from '../../../../../../constants/connections-labels.constants';
import { hasPermission } from '../../../../../../infrastructure/utils/has-permissions';
import { Permission } from '../../../../../../api/roles.dao';
import DefaultButton from '../../../../../global/default-button/default-button';
import { FormattedMessage } from 'react-intl';
import { HOST_MEETING_TEXT } from '../../../_connections/connections.texts';
import TextWithCopyBtn from '../_text-with-copy-btn/text-with-copy-btn';
import { BaseConnectionDetailsPopoverContentProps } from './types';


export const AudioBridgeConnectionDetailsPopoverContent = (props: BaseConnectionDetailsPopoverContentProps): JSX.Element => {
    const { connection, onLinkClick, onCopyBtnClick, audioProviderLabel = ''} = props;

    const {
        type,
        cancelled,
        hostLink,
        label,
        connectionPassword,
        audioProviderId,
        provider,
        participantTelephoneNumbers = '',
        conferenceId,
        participantId,
        operatorTelephoneNumber,
        operatorPin,
        audioBridgeID,
        audioBridgeName,
    } = connection;


    const labels = connectionsDetailsLabels();

    const hostManagementPermission = hasPermission(Permission.HOST_MANAGEMENT);

    let participantTelephoneNumber = '';

    if (participantTelephoneNumbers?.length) {
        [participantTelephoneNumber] = participantTelephoneNumbers.split('\n');
    }

    return (
        <>
            {hostManagementPermission &&
                <div className='connection-list__header'>
                    <DefaultButton
                        className='prominent-button'
                        disabled={!hostLink || cancelled}
                        text={<FormattedMessage {...HOST_MEETING_TEXT} />}
                        onClick={() => onLinkClick(hostLink)}
                    />
                </div>
            }
            {label && <div className='connection-list__field'>{labels.CONNECTION_NAME()}:<br />
                <TextWithCopyBtn message={`${type}: ${label}`} handleCopyClick={onCopyBtnClick} />
            </div>}
            {provider && <div className='connection-list__field'>{labels.PROVIDER()}:<br />
                <TextWithCopyBtn message={provider} handleCopyClick={onCopyBtnClick} />
            </div>}
            {audioBridgeName && <div className='connection-list__field'>{labels.AUDIO_BRIDGE_NAME()}:<br />
                <TextWithCopyBtn message={audioBridgeName} handleCopyClick={onCopyBtnClick} />
            </div>}
            {audioBridgeID && <div className='connection-list__field'>{labels.AUDIO_BRIDGE_ID()}:<br />
                <TextWithCopyBtn message={audioBridgeID} handleCopyClick={onCopyBtnClick} />
            </div>}
            {audioProviderId
                ? <div className='connection-list__field'>{labels.TELEPHONE_NUMBER_SET()}:<br />
                    <TextWithCopyBtn message={audioProviderLabel} handleCopyClick={onCopyBtnClick} />
                </div>
                : <div className='connection-list__field'>{labels.PARTICIPANT_TELEPHONE_NUMBERS()}:<br />
                    <TextWithCopyBtn message={participantTelephoneNumber} handleCopyClick={onCopyBtnClick} />
                </div>
            }
            {conferenceId && <div className='connection-list__field'>{labels.CONFERENCE_ID()}:<br />
                <TextWithCopyBtn message={conferenceId} handleCopyClick={onCopyBtnClick} />
            </div>}
            {participantId && <div className='connection-list__field'>{labels.PARTICIPANT_ID()}:<br />
                <TextWithCopyBtn message={participantId} handleCopyClick={onCopyBtnClick} />
            </div>}
            {connectionPassword && <div className='connection-list__field'>{labels.PASSCODE()}:<br />
                <TextWithCopyBtn message={connectionPassword} handleCopyClick={onCopyBtnClick} />
            </div>}
            {operatorTelephoneNumber && <div className='connection-list__field'>{labels.OPERATOR_TELEPHONE_NUMBER()}:<br />
                <TextWithCopyBtn message={operatorTelephoneNumber} handleCopyClick={onCopyBtnClick} />
            </div>}
            {operatorPin && <div className='connection-list__field'>{labels.OPERATOR_PIN()}:<br />
                <TextWithCopyBtn message={operatorPin} handleCopyClick={onCopyBtnClick} />
            </div>}
        </>
    );
};
